<template>
    <div :class="{ 'fixed bottom-0 left-0 right-0 z-1 ph3 bg-white custom-shadow flex flex-column justify-center': fixed }">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        fixed: {
            type: Boolean,
            required: true
        }
    }
};
</script>
